export default [
	{ path: 'faq', text: 'Delivery Details' },
	{ path: 'faq', text: 'Return Policy' },
	{ path: 'faq', text: 'Frequenty Asked Questions' }
];
